// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./channels"

// Import Preline and make components globally available
import "preline/preline"
import { HSAccordion, HSDropdown, HSOverlay, HSSelect, HSThemeSwitch, HSCollapse } from "preline"

// Make Preline components globally available
window.HSAccordion = HSAccordion
window.HSDropdown = HSDropdown
window.HSOverlay = HSOverlay
window.HSSelect = HSSelect
window.HSThemeSwitch = HSThemeSwitch
window.HSCollapse = HSCollapse

// Import admin-specific code
import "./admin/places_autocomplete"

// Import maps functionality
import "./maps/crawl_map"

// Configure Rails CSRF token for fetch requests
document.addEventListener("DOMContentLoaded", function () {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
  if (token) {
    window.csrfToken = token
  }
  console.log("[DEBUG-APP] DOMContentLoaded in application.js")

  // Initialize Preline components on first load
  if (typeof HSAccordion !== "undefined") HSAccordion.autoInit()
  if (typeof HSDropdown !== "undefined") HSDropdown.autoInit()
  if (typeof HSOverlay !== "undefined") HSOverlay.autoInit()
  if (typeof HSSelect !== "undefined") HSSelect.autoInit()
  if (typeof HSCollapse !== "undefined") HSCollapse.autoInit()
})

// Custom Turbo confirmation handling removed, relying on Turbo's native handling of data-turbo-confirm

document.addEventListener("turbo:load", function (event) {
  // Initialize Preline components
  if (typeof HSAccordion !== "undefined") HSAccordion.autoInit()
  if (typeof HSDropdown !== "undefined") HSDropdown.autoInit()
  if (typeof HSOverlay !== "undefined") HSOverlay.autoInit()
  if (typeof HSSelect !== "undefined") HSSelect.autoInit()
  if (typeof HSCollapse !== "undefined") HSCollapse.autoInit()

  // Make sure the theme switch is explicitly initialized
  try {
    if (typeof HSThemeSwitch !== "undefined") {
      HSThemeSwitch.autoInit()
      console.log("HSThemeSwitch initialized")

      // Update checkbox state based on current theme
      setTimeout(() => {
        const currentTheme = localStorage.getItem("hs_theme") || "default"
        const themeToggle = document.getElementById("dark-mode-switch")
        if (themeToggle) {
          themeToggle.checked = currentTheme === "dark"
          console.log("Set dark mode checkbox to:", themeToggle.checked)
        }
      }, 50)
    }
  } catch (error) {
    console.error("Error initializing HSThemeSwitch:", error)
  }

  // Listen for theme changes
  window.addEventListener("on-hs-appearance-change", (e) => {
    console.log("Theme changed to:", e.detail)

    // Update checkbox when theme changes
    const themeToggle = document.getElementById("dark-mode-switch")
    if (themeToggle) {
      themeToggle.checked = e.detail === "dark"
    }
  })
})
